module.exports = __webpack_public_path__ + "static/c16-139f5c214e8b715b624a8efd042b337b.jpg";